import { Search } from "@/types/Search";
import { SearchFilterV4 } from "@/types/SearchFilter";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Trans } from "@lingui/react/macro";
import { DialogProps } from "@radix-ui/react-dialog";
import Mentions from "./partials/mentions";
import Analytics from "./partials/analytics";

export default function SearchExportDialog({
  filters,
  search,
  ...rest
}: { search: Nullable<Search>; filters: SearchFilterV4 } & DialogProps) {
  // Helpers
  const searchTitle = search?.title;

  return (
    <Dialog {...rest}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Trans>Exportera {searchTitle}</Trans>
          </DialogTitle>
          <DialogDescription>
            <Trans>Exportera bevakningens omnämnanden eller analys.</Trans>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3">
          <Mentions filters={filters} search={search} />
          <Analytics
            filters={filters}
            reportUuid={search?.insights_report_uuid}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
